module.exports = __webpack_public_path__ + "static/Luke.fc954666.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/team/Luke.jpg
// module id = 1308
// module chunks = 137408898365125